import './styles.css';

// The hero tagline is picked by the inline script in index.html's <head> so the
// choice lands before the first paint — nothing to do for it here.

const year = document.getElementById('year');
if (year) year.textContent = String(new Date().getFullYear());
